// if (!customElements.get('collection-layout-switcher')) {
//   customElements.define(
//     'collection-layout-switcher',
//     class CollectionLayoutSwitcher extends window.BAO.CustomElement() {
//       constructor () {
//         super()

//         this.setView = this.setView.bind(this)

//         const view = localStorage.getItem(this.itemKey)

//         if (view) {
//           this.setView(view)
//         }
//       }

//       setupListeners () {
//         super.setupListeners()
//         this.els.trigger.elements.forEach(trigger => {
//           this.listeners.add(
//             trigger,
//             'click',
//             this.handleTriggerClick.bind(this),
//           )
//         })
//       }

//       handleTriggerClick (e) {
//         const layoutTrigger = e.target.closest('.clc-Toolbar_Trigger')
//         const view = layoutTrigger.dataset.view

//         this.setView(view)

//         localStorage.setItem(this.itemKey, view)
//       }

//       setView (view) {
//         const productGrid = this.externalEls?.productGrid?.element

//         if (!productGrid) return

//         productGrid.dataset.view = view

//         this.els.trigger.elements.forEach(trigger => {
//           const isPressed = trigger.dataset.view === view
//           trigger.setAttribute('aria-pressed', isPressed)
//         })

//         window.BAO.dispatchEvent(window.BAO.EVENTS.COLLECTION.LAYOUT_CHANGED, {
//           view,
//         })
//       }

//       get itemKey () {
//         return 'BAO-collection-view'
//       }
//     },
//   )
// }
if (!customElements.get('collection-layout-switcher')) {
  customElements.define(
    'collection-layout-switcher',
    class CollectionLayoutSwitcher extends window.BAO.CustomElement() {
      constructor () {
        super()

        this.setView = this.setView.bind(this)

        this.mql = window.matchMedia('(min-width: 900px)')
      }

      setupListeners () {
        super.setupListeners()
        this.els.trigger.elements.forEach(trigger => {
          this.listeners.add(
            trigger,
            'click',
            this.handleTriggerClick.bind(this),
          )
        })
      }

      handleTriggerClick (e) {
        const view = e.target.dataset.view

        this.setView(view)
      }

      async setView (view) {
        const productGrid = this.externalEls?.productGrid?.element

        if (!productGrid) return

        productGrid.dataset.view = view

        if (this.itemKey === '_collection-view-desktop') {
          productGrid.setAttribute('data-desktop-view', view)
          productGrid.style.setProperty('--desktop-columns', view)
        } else {
          productGrid.setAttribute('data-mobile-view', view)
          productGrid.style.setProperty('--mobile-columns', view)
        }

        this.els.trigger.elements.forEach(trigger => {
          const isPressed = trigger.dataset.view === view
          trigger.setAttribute('aria-pressed', isPressed)
        })

        window.BAO.dispatchEvent(window.BAO.EVENTS.COLLECTION.LAYOUT_CHANGED, {
          view,
        })

        await this.postCartAttribute(this.itemKey, view)
      }

      async postCartAttribute (key, value) {
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                [key]: value,
              },
            }),
          })

          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
        } catch (error) {
          console.error('Failed to update cart attribute:', error)
        }
      }

      get viewport () {
        return this.mql.matches ? 'desktop' : 'mobile'
      }

      get itemKey () {
        return `_collection-view-${this.viewport}`
      }
    },
  )
}
